import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { SearchService } from "../services/search-service";
import { EntityConfigService } from "../services/entity-config-service";
import { DateCalcService } from "../services/date-calc-service";
import { DateLocaleService } from "../services/date-locale-service";
import { EntityCharDataService } from "../services/entity-char-data-service";
import { AclService } from "../services/acl-service";
import { RLCharDataEntityDataController, } from "../ts/rlAdmin.chardatadirectives";
import { RLParentEntityIDController } from "./parent-entity-id";
import { IDateCalcCondition } from "../ts/rlAdmin.models";

export function RLEditDateCalcByCharacteristic() {
    let directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/edit-date-calc-by-characteristic.html"),
        controller: RLEditDateCalcByCharacteristicController,
        controllerAs: "edcVM",
        bindToController: true,
        scope: {
            recCharID: "=recCharId",
            entityID: "=entityId",
            charID: "=charId",
            charLabel: "=",
            templateID: "=templateId",
            fieldDate: "=",
            createMode: "=",
            bulkEdit: "=?",
            cmd: "=",
            commonCmds: "<?",
            firstCatalogItem: "<?",
            firstCatalogItemCharDataCol: "<?"
        },
        require: ["rlEditDateCalcByCharacteristic", "?^rlCharDataEntityData", "?^rlCharDataTableEntityData", "?^rlParentEntityId", "^ngModel"],
        link: ($scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLEditDateCalcByCharacteristicController, RLCharDataEntityDataController, RLCharDataEntityDataController, RLParentEntityIDController, ng.INgModelController]) => {
            if (controllers[1] != null || controllers[2] != null) {
                controllers[0].entityDataCtrl = controllers[1] || controllers[2];
                controllers[0].Initialize();
            }
            if (controllers[0] != null && controllers[3] != null) {
                controllers[0].scopedParentEntityID = controllers[3].parentEntityID;
            }
            if (controllers[0] != null && controllers[4] != null) {
                controllers[0].$ngModel = controllers[4];
            }
        }
    };

    return directive;
}

interface ITableRow {
    charDatas: Models.ICharDatas;
    entityID: string;
    relID: string;
    catalogItemPipeList?: string;
    contactPipeList?: string;
    projectPipeList?: string;
}

interface ICalcRel { calc: Models.ICharDataExtensionDataDateMathCalc; rel: Models.ICharDataExtensionDataDateMathRel; isPerpetuity?: boolean; }

const relativeRightsUrl: string = "/configuration/relativerightsprofiles";

export class RLEditDateCalcByCharacteristicController {

    public static $inject = [
        "$scope",
        "$q",
        "$window",
        "notifyService",
        "entityService",
        "searchService",
        "entityConfigService",
        "dateCalcService",
        "dateLocaleService",
        "entityCharDataService",
        "aclService"
    ];

    public recCharID: number;
    public entityID: string;
    public charID: number;
    public charLabel: string;
    public templateID: number;
    public fieldDate: Models.ICharDataValue;
    public cmd: Models.ICharacteristicMetaData;

    public recID: number;
    private recTitle: string;
    private entityCharTypeID;
    private isEntityModuleLevel: boolean;

    public entityDataCtrl: RLCharDataEntityDataController;

    private createMode: boolean;
    private bulkEdit: boolean;
    public $ngModel: ng.INgModelController;

    private relationships: Models.ICharDataExtensionDataDateMathRel[];
    public childRelationships: Models.ICharDataExtensionDataDateMathRel[];

    public parentInfoList: Models.ICharDataExtensionDataDateMathParentRelInfo[];
    public childrenInfoList: Models.ICharDataExtensionDataDateMathChildRelInfo[];

    private timeFrameLabels: { [key: string]: string };
    public frequencyLabels: { [key: string]: string };
    public conditionLabels: IDateCalcCondition[];

    public dateMathCalcRels: ICalcRel[];

    public get showFindDate1(): boolean {
        this.dateMathCalcRels = this.dateMathCalcRels || [];
        return this.timeframeID == 1 || this.dateMathCalcRels.length == 0;
    }

    public get showFindDate2(): boolean {
        this.dateMathCalcRels = this.dateMathCalcRels || [];
        return this.timeframeID != 1 && this.dateMathCalcRels.length > 0;
    }

    public get showAddSpecificDate() {
        return this.timeframeID ? this.timeframeID != 4 : true;
    }

    public timeframeID: number = null;
    private selectedDateFieldInformation: string;
    private selectedDateFieldFriendlyName: string;
    private hasDateMath: boolean = false;
    public loading: boolean = false;
    public dateCalcTimeframeTypes: Models.IDateCalcTimeframe[] = [];
    public dateCalcFrequencyTypes: Models.IDateCalcFrequency[] = [];
    private dateCalcFrequencyRelativeTypes: Models.IDateCalcFrequencyRelative[] = [];
    private dateCalcRecalcOptionTypes: Models.IDateCalcRecalcOption[] = [];
    public selectedRecalcOptionID: number;

    //Temp values for Additional Date Math
    public tempYearQuantity: number;
    public tempMonthQuantity: number;
    public tempWeekQuantity: number;
    public tempDayQuantity: number;

    public tempFrequencyID: number;
    public tempCalculatePriorTo: boolean;
    //--

    private _showCircularReferenceError: boolean;
    public get showCircularReferenceError(): boolean {
        return this._showCircularReferenceError;
    }

    public set showCircularReferenceError(value: boolean) {
        this._showCircularReferenceError = value;
        if (this.$ngModel != null) {
            this.$ngModel.$setValidity("dateMathCircular2", !value);
        }
    }

    public get getOptionTypes() {
        return this.dateCalcRecalcOptionTypes.filter(t => this.timeframeID == 1 || t.recalcOptionID != 1);
    }

    public onlyAssociatedEntities: boolean;

    private parentEntityID: string;
    private parentEntityTitle: string;
    private parentEntityString: string;

    //Search
    private searchState: Models.IAdvancedSearchModel;
    public charTypeFacets: Models.IKeyValuePair<number, string>[];
    public templateFacets: Models.IKeyValuePair<string, string>[];
    public statusFacets: Models.IKeyValuePair<string, string>[];

    public keywords: string;
    public selectedCharType: number;
    public selectedTemplate: string;
    public selectedStatus: string;
    public showClear: boolean;

    private currentlySelectedDateMathIndex: number = 0;
    public hasSelectedEntity: boolean = false;
    public isComponentCharType: boolean = false;
    private charDataIDsAndNames: Models.ICharacteristicType[];
    private associatedRecords: Models.IKeyValuePair<string, string>[] = [];
    private tempCharTypeFacets: Models.IKeyValuePair<number, string>[] = [];
    private tempSearchRows: Models.IKeyValuePair<any, string>[] = [];
    public searchRows: Models.IKeyValuePair<any, string>[] = [];
    public selectedObjects: Models.IKeyValuePair<any, string>[] = [];
    public showNoResultsMessage: boolean = false;
    private charDateData: Models.IKeyValuePair<string, number>[] = [];
    // --

    //Paging
    public showPaging: boolean;
    public rowCount: number = 10;
    public page: number = 1;
    public pageCount: number;
    public numFound: number;

    public tableViewPage: number = 1;
    public tableViewPageCount: number;
    public tableViewNumFound: number;
    public totalComponentColumns: number;
    private tableEntityID: string;
    private tableCharTypeID: number;
    private tableTemplateID: number;
    private tableRelID: string;
    // --

    //Components
    public showTableView: boolean = false;
    public tableHeaderCells: { tagLabel: string, isDate: boolean, value: string, charID: number }[];
    private tableRows: ITableRow[];
    public pagedTableRows: ITableRow[];
    private tableRowsWithAmounts: number[];
    // --

    //Date Math
    public dateMathTimeframeValues: { value: boolean, text: string }[] = [];
    public showDateMathError: boolean = false;
    public compareToDate: string;
    public calcConditionID: number = 1;
    public calcDateOptionID: boolean = false;
    // --

    //Relative To Catalog
    public commonCmds: Models.ICharacteristicMetaData[];
    public firstCatalogItem: number;
    public firstCatalogItemCharDataCol: Models.ICharDataCollection;
    public isRelativeToCatalog: boolean;
    // --

    //Relative on Mock Entities
    public isRelative: boolean = false;
    public relativeOptions: { value: number, text: string }[] = [
        { value: 1, text: "Date relative to Catalog" }
    ];
    public relativeProfileOption: number;
    private tableParentEntityID: string;
    private tableParentTitle: string;
    // --

    public scopedParentEntityID: string;
    public showSearch = false;

    public sortableOptions: any;
    public get isSortable() {
        return this.timeframeID == 4;
    }

    public constructor(private readonly $scope: ng.IScope,
        private readonly $q: ng.IQService,
        private readonly $window: ng.IWindowService,
        private readonly notifyService: NotifyService,
        private readonly entityService: EntityService,
        private readonly searchService: SearchService,
        private readonly entityConfigService: EntityConfigService,
        private readonly dateCalcService: DateCalcService,
        private readonly dateLocaleService: DateLocaleService,
        private readonly entityCharDataService: EntityCharDataService,
        private readonly aclService: AclService) {

        this.entityCharTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
        this.isEntityModuleLevel = Utils.CharUtil.IsModuleLevelCharType(this.entityCharTypeID);
        this.showCircularReferenceError = false;
        this.selectedCharType = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;

        this.$scope.$watch(() => this.entityID, (newValue, oldValue) => {
            let isOnRelativeRightsPage = this.$window.location.href.toLowerCase().includes(relativeRightsUrl);
            if (newValue && isOnRelativeRightsPage) {
                let charTypeID = Utils.IdBuilder.splitEntityID(newValue).charTypeID;

                //RL-6603 :- Opening this option for all the divs
                this.relativeOptions.push({ value: 3, text: "Date relative to Table row" });

                if (charTypeID == Consts.CharTypeIDs.right || charTypeID == Consts.CharTypeIDs.usage) {
                    this.isRelative = true;
                }
                else {
                    this.isRelative = false;
                }
            }
            else {
                this.isRelative = false;
            }
        }, true);

        this.$scope.$watch(() => this.relativeProfileOption, (newValue, oldValue) => {
            this.searchRows = [];
            this.isRelativeToCatalog = false;
            this.showTableView = false;

            if (newValue) {
                if (newValue == 1) {
                    this.isRelativeToCatalog = true;
                    this.getCommonCmds();
                }
                else if (newValue && newValue == 3) {
                    //Go find the mock table (template 2) object that holds all the rels for Table Triggers
                    this.getTableTriggerParentEntity();
                }

                //There used to be an option 2, but it had the same functionality as the default Date Math, so we're removing.
            }
        });

        this.$scope.$watch(() => this.selectedCharType, (newValue: number, oldValue: number) => {
            if (newValue != oldValue) {
                if ((newValue == null || newValue != oldValue) && !this.hasSelectedEntity && !this.onlyAssociatedEntities) {
                    if (this.selectedTemplate != null && this.selectedTemplate != null) {
                        this.selectedTemplate = null;
                    }

                    if (this.selectedStatus != null && this.selectedStatus != null) {
                        this.selectedStatus = null;
                    }

                    //If the charType is a component, process it differently
                    else if (newValue == Consts.CharTypeIDs.usage ||
                        newValue == Consts.CharTypeIDs.right ||
                        newValue == Consts.CharTypeIDs.royalty ||
                        newValue == Consts.CharTypeIDs.amount) {
                        this.isComponentCharType = true;

                        this.getComponentRows(this.parentEntityID, newValue);
                    } else {
                        this.isComponentCharType = false;
                        this.SearchSubmit();
                    }
                }
            }
        }, true);

        this.$scope.$watch(() => this.selectedTemplate, (newValue: string, oldValue: string) => {
            if (newValue != oldValue) {
                if (!_.isEmpty(newValue)) {
                    if (!_.isEmpty(this.selectedStatus)) {
                        this.selectedStatus = null;
                    } else {
                        this.SearchSubmit();
                    }
                }
            }
        }, true);

        this.$scope.$watch(() => this.selectedStatus, (newValue: string, oldValue: string) => {
            if (newValue != oldValue && newValue != '') {
                this.SearchSubmit();
            }
        }, true);

        $scope.$watch<string[]>(() => [this.keywords, this.selectedStatus, this.selectedTemplate],
            (newValue, oldValue) => {
                this.showClear = _.any(newValue, (val) => !_.isEmpty(val));
            }, true);

        this.$scope.$watch(() => this.onlyAssociatedEntities, (newValue: boolean, oldValue: boolean) => {
            if (newValue != oldValue) {
                this.page = 1;
                this.getEntityTitle()
                    .then(() => {
                        let selectedCharType = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;

                        this.resetFields();

                        if (!this.onlyAssociatedEntities || this.createMode) {
                            if (Utils.CharUtil.IsModuleLevelCharType(selectedCharType)) {
                                this.selectedCharType = selectedCharType;
                            }
                            else {
                                this.selectedCharType = Utils.IdBuilder.splitEntityID(this.parentEntityID).charTypeID;
                            }

                            this.PreSearch();
                        }
                        else {
                            if (this.createMode) {
                                this.PreSearch();
                            } else {
                                this.getModuleParentIDAndTitle(this.entityID)
                                    .then((result) => {
                                        this.tempSearchRows = [];

                                        this.parentEntityID = result.entityID;
                                        this.parentEntityTitle = result.title;
                                        this.parentEntityString = result.entityString;

                                        //Select the char type of the parent entity to start with
                                        this.selectedCharType = Utils.IdBuilder.splitEntityID(result.entityID).charTypeID;

                                        this.tempSearchRows.push({
                                            key: result.entityID,
                                            value: result.title
                                        });

                                        this.searchRows = this.tempSearchRows;
                                    });
                            }
                        }
                    });
            }
        }, true);

        $scope.$watch(() => this.timeframeID, (newValue, oldValue) => {
            if (newValue != null && oldValue != null && newValue != oldValue) {
                this.setTimeframe(newValue);
            }
        });

        this.sortableOptions = {
            orderChanged: (event) => {
                let updated: ICalcRel[] = event.dest.sortableScope.modelValue;
                this.updateDateCalcRelationshipSortOrder(updated);
            }
        }

        $scope.$watchCollection(() => this.dateMathCalcRels, (newValue, oldValue) => {
            let oldLength = (oldValue || []).length;
            let newLength = (newValue || []).length;
            if (newLength !== oldLength) {
                this.updateDateCalcRelationshipSortOrder(newValue);
            }
        });
    }

    public Initialize() {
        this.onlyAssociatedEntities = true;
        this.loadDropDownValues();
        this.loadFromCharData();
        this.loadChildrenInfo();
        this.loadParentInfo();

        this.loadCharDataIDsAndNames()
            .then(() => this.loadModuleCharTypes());
    }

    private extractor<T>(cd: Models.ICharDataValue, ext: (dm: Models.ICharDataExtensionDataDateMath) => T, defaultValue: T) {
        if (cd != null && cd.ext != null && cd.ext.dateMath != null) {
            return ext(cd.ext.dateMath);
        } else {
            return defaultValue;
        }
    }

    private loadFromCharData() {
        this.dateMathCalcRels = this.extractor(this.fieldDate, (dm) => dm.relationships.map(rel => ({ calc: _.find(dm.calcs, calc => calc.dateMathCalcID == rel.dateMathCalcID), rel: rel }))
            .filter(x => x.rel != null), [])
            .sort((x, y) => x.rel.sortOrder - y.rel.sortOrder);

        this.relationships = this.extractor(this.fieldDate, (dm) => dm.relationships, []);
        this.childRelationships = this.extractor(this.fieldDate, (dm) => dm.childRelationships, []);

        if (_.any(this.dateMathCalcRels)) {
            let date = _.first(this.dateMathCalcRels.filter(x => x.calc.compareToDate != null).map(x => x.calc.compareToDate));
            if (date) {
                this.compareToDate = moment(date).format("L");
            }

            let calcConditionID = _.first(this.dateMathCalcRels.map(x => x.calc.calcConditionID));
            if (calcConditionID) {
                this.calcConditionID = calcConditionID;
            }
        }

        this.hasDateMath = _.any(this.dateMathCalcRels) || _.any(this.childRelationships);
        this.calcDateOptionID = _.any(this.dateMathCalcRels) ? this.dateMathCalcRels[0].calc.dateOptionID == 1 ? true: false : false;
        this.selectedRecalcOptionID = _.any(this.dateMathCalcRels) ? this.dateMathCalcRels[0].calc.dateRecalcOptionID : 2;
        this.timeframeID = this.extractor(this.fieldDate, (dm) => _.first(dm.calcs.map(c => c.timeFrameID)), this.timeframeID) || 1;
    }

    private updateDisplay() {
        this.loadFromCharData();
        return this.$q.all([this.loadChildrenInfo(), this.loadParentInfo()]);
    }

    private ensureExtDateMathData() {
        if (this.fieldDate.ext == null) {
            this.fieldDate.ext = {};
        }
        if (this.fieldDate.ext.dateMath == null) {
            this.fieldDate.ext.dateMath = {
                calcs: [],
                calcsChangeTracking: {},
                childRelationships: [],
                relationships: [],
                relationshipChangeTracking: {}
            };
        }
    }

    private ensureExtDateMathCalc() {
        let entityID = Utils.IdBuilder.splitEntityID(this.entityID);

        if (!_.any(this.fieldDate.ext.dateMath.calcs)) {
            let compareToDate = null;
            if (this.compareToDate) {
                compareToDate = moment(this.compareToDate).toDate();
            }
            let calc = {
                charTypeID: entityID.charTypeID,
                divID: entityID.divID,
                recID: entityID.recID,
                recCharID: this.fieldDate.recCharID,
                dateMathCalcID: Utils.IdBuilder.getNewTempRecID(),
                dateMathCalcJson: "",
                dateMathCalcQuantity: null,
                dateRecalcOptionID: this.selectedRecalcOptionID,
                frequencyID: null,
                frequencyIntervalID: null,
                frequencyRelativeIntervalID: null,
                isCalc: false,
                isPriorTo: null,
                timeFrameID: this.timeframeID,
                compareToDate,
                calcConditionID: this.calcConditionID,
                dateOptionID: this.calcDateOptionID == true ? 1 : null
            };
            this.fieldDate.ext.dateMath.calcs.push(calc);
            this.trackCalcAs(calc, "created");
        }
    }

    private ensureRecCharID() {
        if (this.fieldDate.recCharID == 0) {
            this.fieldDate.recCharID = Utils.IdBuilder.getNewTempRecID();
        }
    }

    private setTimeframe(timeframeID: number) {
        if (this.dateMathCalcRels[0] != null) {
            let calcRel = this.dateMathCalcRels[0];
            calcRel.calc.timeFrameID = timeframeID;
            if (timeframeID != 1 && this.selectedRecalcOptionID == 1) {
                calcRel.calc.dateRecalcOptionID = 3;
            }
            this.trackCalcAs(calcRel.calc, "updated");
        }
        this.loadFromCharData();
        this.resetFields();
    }

    private loadParentInfo() {
        if (_.any(this.relationships)) {
            let entityID = Utils.IdBuilder.splitEntityID(this.entityID);

            let localRels = this.relationships.filter(rel => rel.parentCharTypeID == entityID.charTypeID && rel.parentRecID == entityID.recID);
            let nonLocalRels = this.relationships.filter(rel => !(rel.parentCharTypeID == entityID.charTypeID && rel.parentRecID == entityID.recID));
            let localPromise = this.$q.when<Models.ICharDataExtensionDataDateMathParentRelInfo[]>(this.entityDataCtrl.GetContextDateMathParentRelationshipInfo(localRels));
            let nonLocalPromise = this.dateCalcService.getDateMathCalcParentInfo(nonLocalRels);

            return this.$q.all([localPromise, nonLocalPromise])
                .then((results: Models.ICharDataExtensionDataDateMathParentRelInfo[][]) => {
                    this.parentInfoList = _.flatten(results);
                });

        } else {
            return this.$q.when();
        }
    }

    private loadChildrenInfo() {
        if (_.any(this.childRelationships)) {
            return this.dateCalcService.getDateMathCalcChildrenInfo(this.childRelationships)
                .then((result) => {
                    this.childrenInfoList = result;
                });
        } else {
            return this.$q.when();
        }
    }

    public GetDescription(dateMathCalcRel: ICalcRel) {
        if (this.parentInfoList != null) {
            let parentInfo = _.find(this.parentInfoList, (pi) => pi.dateMathRelID == dateMathCalcRel.rel.dateMathRelID);
            if (parentInfo != null) {
                if (parentInfo.currentValue == Consts.DateMath.PerpetutityDateValue || parentInfo.currentValue == "Perpetuity") {
                    dateMathCalcRel.isPerpetuity = true;

                    //Clear out Quantity, Frequency, Prior to, and Offset
                    dateMathCalcRel.rel.yearQuantity = null;
                    this.tempYearQuantity = null;
                    dateMathCalcRel.rel.monthQuantity = null;
                    this.tempMonthQuantity = null;
                    dateMathCalcRel.rel.weekQuantity = null;
                    this.tempWeekQuantity = null;
                    dateMathCalcRel.rel.dayQuantity = null;
                    this.tempDayQuantity = null;

                    dateMathCalcRel.rel.frequencyID = null;
                    this.tempFrequencyID = null;
                    dateMathCalcRel.rel.isPriorTo = false;
                    this.tempCalculatePriorTo = false;
                }
                else {
                    dateMathCalcRel.isPerpetuity = false;
                }

                return this.formatRelInfo(parentInfo);
            }
        }
        return null;
    }

    private formatRelInfo(relInfo: { dateMathRelID: number, path: string; currentValue: string }) {
        let rel = _.find(this.relationships, (rel) => rel.dateMathRelID == relInfo.dateMathRelID);

        let isRelative = !!rel && !!rel.relativeCatalogID;
        if (isRelative) {
            // replace catalog specific name with general name since we will be substituting catalogid when saving
            return relInfo.path.replace(/^[^>;]*\>/, "Relative to Catalog >");
        }

        let output = "";
        switch (relInfo.currentValue) {
            case Consts.DateMath.BlankDateValue:
            case "":
            case null:
                output = "[no date value set]";
                break;
            case Consts.DateMath.PerpetutityDateValue:
            case "Perpetuity":
                output = "Perpetuity";
                break;
            default:
                let currentMoment = this.dateLocaleService.parseStorageMoment(relInfo.currentValue);
                if (currentMoment.isValid()) {
                    output = this.dateLocaleService.localizeMoment(currentMoment).format("L");
                } else {
                    output = "[invalid date]";
                }
                break;
        }
        if (output != "") {
            output = `${relInfo.path} | ${output}`;
        }
        return output;
    }

    private trackCalcAs(calc: Models.ICharDataExtensionDataDateMathCalc, status: "updated" | "deleted" | "created") {
        switch (status) {
            case "created":
                this.setCalcChangeTracking(calc.dateMathCalcID, 1);
                break;
            case "updated":
                if (calc.dateMathCalcID > 0) {
                    this.setCalcChangeTracking(calc.dateMathCalcID, 0);
                }
                break;
            case "deleted":
                if (calc.dateMathCalcID > 0) {
                    this.setCalcChangeTracking(calc.dateMathCalcID, -1);
                } else {
                    this.setCalcChangeTracking(calc.dateMathCalcID, null);
                }
            default:
                break;
        }
    }

    private trackRelAs(rel: Models.ICharDataExtensionDataDateMathRel, status: "updated" | "deleted" | "created") {
        switch (status) {
            case "created":
                this.setRelChangeTracking(rel.dateMathRelID, 1);
                break;
            case "updated":
                if (rel.dateMathRelID > 0) {
                    this.setRelChangeTracking(rel.dateMathRelID, 0);
                }
                break;
            case "deleted":
                if (rel.dateMathRelID > 0) {
                    this.setRelChangeTracking(rel.dateMathRelID, -1);
                } else {
                    this.setRelChangeTracking(rel.dateMathRelID, null);
                }
            default:
                break;
        }
    }

    private setCalcChangeTracking(calcID: number, status: -1 | 0 | 1 | null) {
        this.ensureExtDateMathData();
        if (status == null) {
            delete this.fieldDate.ext.dateMath.calcsChangeTracking[calcID];
        } else {
            this.fieldDate.ext.dateMath.calcsChangeTracking[calcID] = status;
        }
    }

    private setRelChangeTracking(relID: number, status: -1 | 0 | 1 | null) {
        this.ensureExtDateMathData();
        if (status == null) {
            delete this.fieldDate.ext.dateMath.relationshipChangeTracking[relID];
        } else {
            this.fieldDate.ext.dateMath.relationshipChangeTracking[relID] = status;
        }
    }

    public RecalcOptionIDChanged() {
        let newValue = this.selectedRecalcOptionID;
        this.dateMathCalcRels
            .filter((calcRel) => calcRel.calc.dateRecalcOptionID != newValue)
            .forEach((calcRel) => {
                calcRel.calc.dateRecalcOptionID = newValue;
                this.trackCalcAs(calcRel.calc, "updated");
            });
        this.loadFromCharData();
    }

    private setDateMath(parentEntityID: string, charID: number, recCharID: number, isRelativeToCatalog: boolean = false) {
        this.ensureRecCharID();
        this.ensureExtDateMathData();
        this.ensureExtDateMathCalc();

        this.notifyService.startProgress();
        let promise: ng.IPromise<number> = null;

        let splitParentEntityID = Utils.IdBuilder.splitEntityID(parentEntityID);

        if (recCharID > 0) {
            promise = this.$q.when(recCharID);
        } else if (this.entityID == parentEntityID) {
            promise = this.$q.when(this.entityDataCtrl.GetNewDateMathTargetRecCharID(charID));
        } else {
            let recCharID2 = this.entityCharDataService.CheckForRecCharData(parentEntityID, charID);
            if (recCharID2 > 0) {
                promise = this.$q.when(recCharID2);
            } else {
                if (splitParentEntityID.recID != -1 && this.relativeProfileOption != 1) {
                    promise = this.createDateFieldRecCharID(parentEntityID, charID)
                        .then((response) => {
                            let recCharID = response.data;
                            this.entityCharDataService.CreatedRecCharData(parentEntityID, charID, recCharID);
                            return recCharID;
                        });
                }
                else {
                    //We are creating datemath relative to something that does not exist.  Instead, we'll change this to be a fake record id
                    promise = this.$q.when(-1000 * charID);
                }
            }
        }

        return promise
            .then((targetRecCharID) => {
                //this.fieldDate.value = Consts.DateMath.BlankDateValue;  undoing to reverse MVCA-3187
                if (this.fieldDate.ext.dateMath.relationships[this.currentlySelectedDateMathIndex] == null) {
                    let rel: Models.ICharDataExtensionDataDateMathRel = {
                        dateMathCalcID: this.fieldDate.ext.dateMath.calcs[0].dateMathCalcID,
                        dateMathRelID: Utils.IdBuilder.getNewTempRecID(),
                        divID: splitParentEntityID.divID,
                        parentCharTypeID: splitParentEntityID.charTypeID,
                        parentRecCharID: targetRecCharID,
                        parentRecID: splitParentEntityID.recID,
                        recCharID: this.fieldDate.recCharID,
                        yearQuantity: null,
                        monthQuantity: null,
                        weekQuantity: null,
                        dayQuantity: null,
                        frequencyID: null,
                        isPriorTo: null,
                        sortOrder: 0
                    };

                    rel.relativeCatalogID = isRelativeToCatalog ? charID : null;
                    this.fieldDate.ext.dateMath.relationships.push(rel);
                    this.trackRelAs(rel, "created");
                } else {
                    let rel = this.fieldDate.ext.dateMath.relationships[this.currentlySelectedDateMathIndex];
                    rel.parentCharTypeID = splitParentEntityID.charTypeID;
                    rel.parentRecID = splitParentEntityID.recID;
                    rel.parentRecCharID = targetRecCharID;
                    rel.relativeCatalogID = isRelativeToCatalog ? charID : null;
                    this.trackRelAs(rel, "updated");
                }
            })
            .then(() => {
                this.notifyService.endProgress();
                this.updateDisplay();
            });
    }

    //Utilities
    private loadDropDownValues() {
        this.notifyService.startProgress();

        let dateCalcTimeframePromise = this.dateCalcService.getDateCalcTimeframeList()
            .then((results) => {
                this.dateCalcTimeframeTypes = results;
                this.timeFrameLabels = _.transform<Models.IDateCalcTimeframe, string>(results, (acc, item) => acc[item.timeframeID] = item.timeframeLabel, {});
            });

        let dateCalcFrequencyPromise = this.dateCalcService.getDateCalcFrequencyList()
            .then((results) => {
                this.dateCalcFrequencyTypes = _.filter(results, r => _.includes([1, 5], r.frequencyID));
                this.frequencyLabels = _.transform<Models.IDateCalcFrequency, string>(results, (acc, item) => acc[item.frequencyID] = item.frequencyLabel, {});
            });

        let dateCalcFrequencyRelativePromise = this.dateCalcService.getDateCalcFrequencyRelativeList()
            .then((results) => {
                this.dateCalcFrequencyRelativeTypes = results;
            });

        let dateCalcRecalcOptionPromise = this.dateCalcService.getDateCalcRecalcOptionList()
            .then((results) => {
                this.dateCalcRecalcOptionTypes = results;
            });

        let dateCalcConditionPromise = this.dateCalcService.getDateCalcConditionList()
            .then((results) => {
                this.conditionLabels = results;
            });

        this.dateMathTimeframeValues = [];
        this.dateMathTimeframeValues.push({ value: true, text: "Before" });
        this.dateMathTimeframeValues.push({ value: false, text: "After" });

        let promises = [dateCalcTimeframePromise, dateCalcFrequencyPromise, dateCalcFrequencyRelativePromise, dateCalcRecalcOptionPromise];

        return this.$q.all(promises)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private loadModuleCharTypes() {
        this.tempCharTypeFacets = [];

        let moduleCharTypes = Utils.CharUtil.GetModuleLevelCharTyps(false);

        moduleCharTypes.forEach(mct => {
            let charName = this.getCharDataName(mct);

            this.tempCharTypeFacets.push({
                key: mct,
                value: charName
            });
        });

        this.charTypeFacets = this.tempCharTypeFacets;
    }

    private loadCharDataIDsAndNames() {
        this.charDataIDsAndNames = [];

        return this.entityConfigService.getCharacteristicTypes()
            .then((results) => {
                this.charDataIDsAndNames = results;

                //We need to make sure this says Accounting and not Invoice
                let invoiceCharType = _.find(this.charDataIDsAndNames, c => c.charTypeID == 7);

                if (invoiceCharType) {
                    invoiceCharType.charTypeName = "Accounting";
                }
            });
    }

    private getEntityTitle(): ng.IPromise<any> {
        if (this.createMode) {
            return this.$q.when();
        } else {
            return this.entityService.getEntity(this.entityID)
                .then((results) => {
                    this.recTitle = results.record.title;
                });
        }
    }

    private getCharDataName(charTypeID: number): string {
        if (charTypeID != null && this.charDataIDsAndNames && this.charDataIDsAndNames.length > 0) {
            return _.find(this.charDataIDsAndNames, c => c.charTypeID == charTypeID).charTypeName;
        }
        else
            return "";
    }

    private getModuleParentIDAndTitle(childEntityID: string, isExistingDateMath: boolean = false) {
        this.notifyService.startProgress();
        let deferred = this.$q.defer<Models.IParentEntityIDAndTitle>();
        let splitEntityID = Utils.IdBuilder.splitEntityID(childEntityID);
        let promises: ng.IPromise<any>[] = [];

        let parentEntityInfo: Models.IParentEntityIDAndTitle = {
            entityID: "",
            entityString: "",
            title: ""
        };

        if (!Utils.CharUtil.IsModuleLevelCharType(splitEntityID.charTypeID)) {

            let relPromise: ng.IPromise<Models.IEntityRelationship[]> = null;
            if (splitEntityID.charTypeID == Consts.CharTypeIDs.relationship) {
                relPromise = this.entityService.getEntityRelationship(childEntityID).then((result) => <Models.IEntityRelationship[]>[result]);
            } else {
                relPromise = this.entityService.getEntityParentRelationship(childEntityID);
            }

            promises.push(
                relPromise
                    .then((parents) => {
                        let parentRel: Models.IEntityRelationship = _.first(parents);

                        if (!isExistingDateMath) {
                            if (parents.length > 1) {
                                let parentPath = this.$window.location.pathname;

                                if (parentPath.toLowerCase().indexOf("/contract/") == 0) {
                                    //We're on a deal
                                    parentRel = _.first(parents.filter(p => p.parentCharTypeID == Consts.CharTypeIDs.transaction));
                                }
                                else if (parentPath.toLowerCase().indexOf("/asset/") == 0) {
                                    //We're on a catalog item
                                    parentRel = _.first(parents.filter(p => p.parentCharTypeID == Consts.CharTypeIDs.property));
                                }

                                if (parentRel == null) {
                                    //This means there was no parent rel for a Deal or Catalog, which may mean we have a Relationshp char type, look for that
                                    parentRel = _.first(parents.filter(p => p.parentCharTypeID == Consts.CharTypeIDs.relationship));
                                }
                            }
                        }

                        return this.searchService.findRootModuleLevelEntity(parentRel)
                            .then((rootEntity) => {
                                parentEntityInfo.entityID = rootEntity.data.entityID;
                                parentEntityInfo.title = rootEntity.data.title;
                                parentEntityInfo.entityString = this.getCharDataName(rootEntity.data.charTypeID) + " " + rootEntity.data.recordID + " " + "\"" + rootEntity.data.title + "\""; //this.parentEntityString
                            });
                    }));
        }
        else {
            parentEntityInfo.entityID = childEntityID;
            promises.push(this.entityService.getEntity(childEntityID)
                .then((results) => {
                    parentEntityInfo.title = results.record.title;
                }));
            promises.push(this.entityService.getEntityRecord(childEntityID)
                .then((entity) => {
                    parentEntityInfo.entityString = this.getCharDataName(splitEntityID.charTypeID) + " " + splitEntityID.recID + " " + "\"" + entity.title + "\"";
                }));
        }

        this.$q.all(promises)
            .then(() => {
                deferred.resolve(parentEntityInfo);
            })
            .finally(() => {
                this.notifyService.endProgress();

            });

        return deferred.promise;
    }

    private createDateFieldRecCharID(entityID: string, characteristicID: number): ng.IPromise<Models.IDataResponse<number>> {
        let splitEntityID = Utils.IdBuilder.splitEntityID(entityID);
        return this.dateCalcService.createDateCalcCharacteristic(splitEntityID.charTypeID, splitEntityID.recID, characteristicID, null, null);
    }

    private resetFields() {
        this.checkForCircularReference(this.recCharID);
        this.ClearSearch();
    }

    private checkForDefaultCharType(collectionToCheck) {
        if (this.selectedCharType == null) {
            this.selectedCharType = _.first(this.tempCharTypeFacets).key;
        }
    }

    private getCharDateData(entityID) {
        this.showPaging = false;

        let charDataPromise: ng.IPromise<Models.ICharDataCollection>;
        if (Utils.IdBuilder.splitEntityID(entityID).recID > 0) {
            charDataPromise = this.dateCalcService.getEntityCharDataDates(entityID);
        } else {
            charDataPromise = this.$q.when(this.entityDataCtrl.GetDateMathCharDatas());
        }

        charDataPromise
            .then((result) => {
                // if we're pointing at ourselves, remove the current cmd to prevent self-referencing
                if (this.entityID == entityID) {
                    delete result.charDatas[this.cmd.tagLabel];
                }
                return result;
            })
            .then((results) => {
                this.tempSearchRows = [];

                for (let tag in results.charDatas) {

                    let charData = results.charDatas[tag];

                    if (charData.length > 0) {
                        let isSameFieldOnCurrentRecordUsingRecCharID = entityID == this.entityID && (charData[0].recCharID == this.recCharID && this.recCharID > 0);
                        let isSameFieldOnCurrentRecordUsingCharID = entityID == this.entityID && (charData[0].charID == this.recCharID);
                        let isSameFieldOnCurrentRecordUsingLabel = entityID == this.entityID && charData[0].value.match(this.charLabel) != null;

                        if (!isSameFieldOnCurrentRecordUsingRecCharID && !isSameFieldOnCurrentRecordUsingCharID && !isSameFieldOnCurrentRecordUsingLabel) {
                            moment.locale(navigator.language);
                            let dataSplit = charData[0].value.split('|');
                            let fieldValue = _.first(dataSplit);
                            let dateValue = _.last(dataSplit);
                            if (moment(dateValue).isValid()) {
                                dateValue = moment(dateValue).format("L");
                            }
                            this.tempSearchRows.push({
                                key: "|" + charData[0].recCharID.toString(),
                                value: `${fieldValue} | ${dateValue}`
                            });

                            this.charDateData.push({
                                key: `${fieldValue} | ${dateValue}`,
                                value: charData[0].charID
                            });
                        }
                    }
                }

                if (this.tempSearchRows.length == 0) {
                    this.showNoResultsMessage = true;
                }
                else {
                    this.showNoResultsMessage = false;

                    this.tempSearchRows.sort((sr1, sr2) => {
                        return sr1.value > sr2.value ? 1 : -1;
                    });
                }

                this.searchRows = this.tempSearchRows;
            });
    }

    private parseRecCharID(key: string): number {
        let recCharID: number;

        if (key.indexOf("|") == 0) {
            let potentialRecCharID = key.substr(1);

            if (_.parseInt(potentialRecCharID) != null) {
                recCharID = _.parseInt(potentialRecCharID);
            }
        }

        return recCharID;
    }

    private checkForCircularReference(parentRecCharID: number): ng.IPromise<any> {
        let hasSelfCircularReference = this.entityDataCtrl.CheckSelfForCircularDateMathReferences(this.recCharID, parentRecCharID);
        let hasBulkCircularReference = Utils.DateUtil.CheckForCircularDateMathReferences(this.entityCharDataService.GetAllDateMathCharDatas(), this.recCharID, parentRecCharID);

        return this.dateCalcService.hasCircularReference(this.recCharID, parentRecCharID)
            .then((result) => {
                this.showCircularReferenceError = result.data || hasSelfCircularReference || hasBulkCircularReference;
            });
    }

    public IsAmountRow(recID) {
        let recordID = recID;
        if (Utils.IdBuilder.isEntityID(recID)) {
            recordID = Utils.IdBuilder.splitEntityID(recID).recID;
        }
        return this.tableRowsWithAmounts.filter(t => t == _.parseInt(recordID)).length > 0;
    }
    //--

    public FindAnother() {
        this.PreSearch(this.dateMathCalcRels.length);
        this.showTableView = false;
        this.showSearch = true;
    }

    //Search
    public PreSearch(index?: number) {
        this.tempSearchRows = [];
        this.selectedObjects = [];
        this.hasSelectedEntity = false;
        this.showTableView = false;

        if (index != null) {
            this.currentlySelectedDateMathIndex = index;
        }

        if (!this.onlyAssociatedEntities) {
            //Check the type of entity we're on, if it's a component level entity, we need to treat it differently than a module level entity

            if (this.isEntityModuleLevel && (
                this.selectedCharType == Consts.CharTypeIDs.usage ||
                this.selectedCharType == Consts.CharTypeIDs.right ||
                this.selectedCharType == Consts.CharTypeIDs.royalty ||
                this.selectedCharType == Consts.CharTypeIDs.amount)) {
                this.isComponentCharType = true;
                this.getComponentRows(this.entityID, this.selectedCharType);
            } else {
                this.searchCharModule()
                    .then(() => {
                        this.charTypeFacets = this.tempCharTypeFacets;
                        this.searchRows = this.tempSearchRows;
                    });
            }
        } else {
            //Deal with Relative Profile options
            if (this.relativeProfileOption == 3) {

                this.selectedCharType = Utils.IdBuilder.splitEntityID(this.tableParentEntityID).charTypeID;

                this.tempSearchRows.push({
                    key: this.tableParentEntityID,
                    value: this.tableParentTitle
                });

                this.searchRows = this.tempSearchRows;
                return;
            } else if (this.createMode) {
                if (!_.isEmpty(this.scopedParentEntityID)) {
                    this.getModuleParentIDAndTitle(this.scopedParentEntityID)
                        .then((result) => {
                            this.parentEntityID = result.entityID;
                            this.parentEntityTitle = result.title;
                            this.parentEntityString = result.entityString;

                            //Select the char type of the parent entity to start with
                            this.selectedCharType = Utils.IdBuilder.splitEntityID(result.entityID).charTypeID;

                            this.tempSearchRows.push({
                                key: result.entityID,
                                value: result.title
                            });

                            if (!this.bulkEdit) {
                                this.tempSearchRows.push({
                                    key: this.entityID,
                                    value: this.entityDataCtrl.GetEntityTitle()
                                });
                            }
                            this.searchRows = this.tempSearchRows;
                        });
                } else {
                    this.tempSearchRows.push({
                        key: this.entityID,
                        value: this.entityDataCtrl.GetEntityTitle()
                    });
                    this.searchRows = this.tempSearchRows;
                }

            } else {
                this.getModuleParentIDAndTitle(this.entityID)
                    .then((result) => {
                        this.parentEntityID = result.entityID;
                        this.parentEntityTitle = result.title;
                        this.parentEntityString = result.entityString;

                        //Select the char type of the parent entity to start with
                        this.selectedCharType = Utils.IdBuilder.splitEntityID(result.entityID).charTypeID;

                        this.tempSearchRows.push({
                            key: result.entityID,
                            value: result.title
                        });
                        this.searchRows = this.tempSearchRows;
                    });
            }
        }
    }

    private searchCharModule(entityID: string = this.entityID, selectedCharType: number = this.selectedCharType): ng.IPromise<any> {
        this.notifyService.startProgress();
        this.loading = true;
        this.showPaging = true;
        this.showNoResultsMessage = false;
        let selectedCharTypeID = null;

        if (selectedCharType != -1) {
            selectedCharTypeID = selectedCharType;
        } else if (this.selectedCharType != null) {
            selectedCharTypeID = this.selectedCharType;
        }

        let searchRequest: Models.IAdvancedSearchModel = {
            charTypeID: selectedCharTypeID,
            searchGroups: [],
            keywords: this.keywords,
            page: this.page,
            rowCount: this.rowCount,
            template: this.selectedTemplate,
            status: this.selectedStatus,
            sortDir: 0,
            sortField: "title_sort",
            relatedEntityID: this.onlyAssociatedEntities || this.hasSelectedEntity ? entityID : "",
            explicitRelationshipsOnly: selectedCharTypeID == Consts.CharTypeIDs.property ? true : false
        };

        return this.searchService.advancedSearch(searchRequest)
            .then((result) => {
                this.tempSearchRows = [];
                this.searchRows = [];

                result.documents.forEach((row) => {
                    this.showNoResultsMessage = false;

                    this.tempSearchRows.push({
                        key: row.entityID,
                        value: row.title
                    });

                    let charTypeName = this.getCharDataName(row.charTypeID);

                    //We use these collections later to find information on the entity
                    this.associatedRecords.push({
                        key: row.entityID,
                        value: charTypeName + " " + row.recordID + " " + "\"" + row.title + "\""
                    });
                });

                //Meta Data for dropdowns
                this.templateFacets = result.getTemplateFacets();
                this.statusFacets = result.getStatusFacets();

                //Meta Data for paging
                this.numFound = result.numFound;
                this.pageCount = Math.ceil(result.numFound / this.rowCount);
            })
            .finally(() => {
                this.tempSearchRows.sort((sr1, sr2) => {
                    return sr1.value > sr2.value ? 1 : -1;
                });

                if (this.tempSearchRows.length == 0 && !this.isComponentCharType) {
                    this.showNoResultsMessage = true;
                }

                this.searchState = searchRequest;
                this.loading = false;
                this.notifyService.endProgress();
            });
    }

    public SearchSubmit() {
        this.tempSearchRows = [];
        this.page = 1;
        let selectedEntity = this.parentEntityID;

        if (this.selectedObjects.length > 0) {
            selectedEntity = this.selectedObjects[0].key;
        }

        let lastSelectedObject = _.last(this.selectedObjects);
        if (!lastSelectedObject) {
            this.searchCharModule(selectedEntity)
                .then(() => {
                    this.searchRows = this.tempSearchRows;
                });
            return;
        }
        if (Utils.CharUtil.IsModuleLevelCharType(lastSelectedObject.key)) {
            this.searchCharModule(selectedEntity, lastSelectedObject.key)
                .then(() => {
                    this.searchRows = this.tempSearchRows;
                });
            return;
        }
        if (Utils.IdBuilder.isTemplateID(lastSelectedObject.key)) {
            let splitTemplate = Utils.IdBuilder.splitTemplateID(lastSelectedObject.key);
            this.createTableView(selectedEntity, splitTemplate.templateID, splitTemplate.charTypeID);
        }
    }

    public ClearSearch($event?: ng.IAngularEvent) {
        if ($event != null) {
            $event.preventDefault();
        }

        this.showTableView = false;
        this.hasSelectedEntity = false;
        this.showPaging = false;
        this.selectedDateFieldInformation = "";
        this.tempSearchRows = [];
        this.searchRows = [];
        this.keywords = "";
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.checkForDefaultCharType(this.charTypeFacets);

        if (!this.onlyAssociatedEntities) {
            this.PreSearch();
        }
        if (this.selectedObjects.length > 0) {
            this.SelectRow(this.selectedObjects[this.selectedObjects.length - 1]);
        }
    }

    public RevertSearchTo(index: number) {
        this.showTableView = false;
        this.showNoResultsMessage = false;
        this.tempSearchRows = [];
        this.searchRows = [];
        this.selectedObjects = this.selectedObjects.slice(0, index);
        this.keywords = "";

        if (index - 1 < 0) {
            this.showTableView = false;
            this.hasSelectedEntity = false;
            this.selectedObjects = [];
            this.selectedTemplate = null;
            this.selectedStatus = null;
            this.page = 1;

            if (this.onlyAssociatedEntities) {
                if (this.createMode) {
                    this.showPaging = false;
                    this.PreSearch();

                } else {
                    this.getModuleParentIDAndTitle(this.entityID)
                        .then((result) => {
                            this.tempSearchRows = [];

                            this.parentEntityID = result.entityID;
                            this.parentEntityTitle = result.title;
                            this.parentEntityString = result.entityString;

                            //Select the char type of the parent entity to start with
                            this.selectedCharType = Utils.IdBuilder.splitEntityID(result.entityID).charTypeID;

                            this.tempSearchRows.push({
                                key: result.entityID,
                                value: result.title
                            });

                            this.searchRows = this.tempSearchRows;
                        });
                }
            }
            else {
                this.SearchSubmit();
            }
        }
        else {
            if (this.selectedObjects.length == 1) {
                this.hasSelectedEntity = false;
            }

            this.SelectRow(this.selectedObjects[index - 1]);
        }
    }
    //--

    //Paging
    public PageChanged(page: number) {
        this.page = page;

        if (this.selectedObjects.length > 0) {
            //First check if the row key is an entityID or not
            let lastItemKey = this.selectedObjects[this.selectedObjects.length - 1].key;

            let isEntityID = Utils.IdBuilder.isEntityID(lastItemKey);
            let isTemplateID = Utils.IdBuilder.isTemplateID(lastItemKey);
            //We want the second to last selected object as that will be our entity for some cases
            let lastSelectedEntity = this.parentEntityID;

            if (this.selectedObjects.length >= 2) {
                lastSelectedEntity = this.selectedObjects[this.selectedObjects.length - 2].key;
            }

            if (isEntityID) {
                //Do nothing, not currently applicable
            }
            else if (isTemplateID) {
                //This is controlled in TablePageSizeChanged
            }
            else {
                this.searchCharModule(lastSelectedEntity, lastItemKey)
                    .then(() => {
                        this.searchRows = this.tempSearchRows;
                    });
            }
        }
        else {
            this.searchCharModule()
                .then(() => {
                    this.searchRows = this.tempSearchRows;
                });
        }
    }

    public PageSizeChanged(pageSize: number) {
        this.page = 1;
        this.rowCount = pageSize;

        if (this.selectedObjects.length > 0) {
            //First check if the row key is an entityID or not
            let lastItemKey = this.selectedObjects[this.selectedObjects.length - 1].key;

            let isEntityID = Utils.IdBuilder.isEntityID(lastItemKey);
            let isTemplateID = Utils.IdBuilder.isTemplateID(lastItemKey);
            //We want the second to last selected object as that will be our entity for some cases
            let lastSelectedEntity = this.parentEntityID;

            if (this.selectedObjects.length >= 2) {
                lastSelectedEntity = this.selectedObjects[this.selectedObjects.length - 2].key;
            }

            if (isEntityID) {
                //Do nothing, not currently applicable
            }
            else if (isTemplateID) {
                //This is controlled in TablePageSizeChanged
            }
            else {
                this.searchCharModule(lastSelectedEntity, lastItemKey)
                    .then(() => {
                        this.searchRows = this.tempSearchRows;
                    });
            }
        }
        else {
            this.searchCharModule()
                .then(() => {
                    this.searchRows = this.tempSearchRows;
                });
        }

    }

    public TablePageChanged(page: number) {
        this.tableViewPage = page;
        if (this.tableRelID) {
            this.createAmountTableView(this.tableRelID);
        } else {
            this.createTableView(this.tableEntityID, this.tableTemplateID, this.tableCharTypeID);
        }
    }

    public TablePageSizeChanged(pageSize: number) {
        this.tableViewPage = 1;
        this.rowCount = pageSize;
        if (this.tableRelID) {
            this.createAmountTableView(this.tableRelID);
        } else {
            this.createTableView(this.tableEntityID, this.tableTemplateID, this.tableCharTypeID);
        }
    }


    //UI Actions
    public SelectRow(row: Models.IKeyValuePair<any, string>, selectedComponentEntity?: string) {
        this.searchRows = [];

        //Clear out the search criteria
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.keywords = "";

        //If we are at the lowest level (we have a rec char ID for the selected date field), then select it and close the drop panel
        let recCharID = this.parseRecCharID(row.key.toString());
        let charID = _.last(this.charDateData.filter(cdd => cdd.key == row.value).map(cdd => cdd.value));

        if (recCharID != null) {

            if (recCharID == 0 && !_.isEmpty(selectedComponentEntity)) {
                let newRecCharID = this.entityCharDataService.CheckForRecCharData(selectedComponentEntity.split("|")[0], charID);
                if (newRecCharID) {
                    this.checkForCircularReference(newRecCharID);
                }
            }

            //this.EnsureRecCharID();
            if (recCharID != 0 && this.recCharID != 0) {
                //Check for a circular reference
                if (recCharID == this.recCharID) {
                    //This is a link to the same field. Show the error
                    this.showCircularReferenceError = true;
                }
                else {
                    this.loading = true;
                    this.checkForCircularReference(recCharID);
                }
            }
            else {
                this.showCircularReferenceError = false;
            }

            this.closeSearchDropPanel();
            this.processSelectedDateField(this.currentlySelectedDateMathIndex, recCharID, charID, row.value, selectedComponentEntity);

            this.loading = false;

            return;
        }

        //Only add the row if it doesn't exist
        if (this.selectedObjects.length == 0 || _.last(this.selectedObjects).key != row.key) {
            this.selectedObjects.push({
                key: row.key,
                value: row.value
            });
        }

        //First check if the row key is an entityID or not
        let isEntityID = Utils.IdBuilder.isEntityID(row.key);
        let isTemplateID = Utils.IdBuilder.isTemplateID(row.key);
        //We want the second to last selected object as that will be our entity for some cases
        let lastSelectedEntity = this.parentEntityID;
        if (this.selectedObjects.length >= 2) {
            let lastEntity = _(this.selectedObjects)
                .findLast(kvp => Utils.IdBuilder.isEntityID(kvp.key) && Utils.IdBuilder.splitEntityID(kvp.key).charTypeID != 0);
            if (lastEntity) {
                lastSelectedEntity = lastEntity.key;
            }
        }

        if (isEntityID) {
            let charTypeID = Utils.IdBuilder.splitEntityID(row.key).charTypeID;

            if (Utils.CharUtil.IsModuleLevelCharType(charTypeID) || (this.createMode && this.tableCharTypeID != Consts.CharTypeIDs.usage)) {
                this.showTableView = false;
                this.selectEntityRow(row.key, charTypeID);
            }
            else {
                this.selectComponentRow(row.key, row);
            }
        }
        else if (isTemplateID) {
            //Show the child rows of that template in a table view
            this.selectComponentRow(lastSelectedEntity, row);
        }
        else {
            let selectedEntityCharTypeID = Utils.IdBuilder.splitEntityID(this.selectedObjects[0].key).charTypeID;
            //If the char type is the same as the selected entity, then we're selecting its Details
            if (row.value == "Details") {
                this.showTableView = false;
                let recID = Utils.IdBuilder.splitEntityID(lastSelectedEntity).recID;
                this.getCharDateData(lastSelectedEntity);
            }
            else if (Utils.CharUtil.IsModuleLevelCharType(row.key)) {
                //Show the entities of that char type in a list view
                this.searchCharModule(lastSelectedEntity, row.key)
                    .then(() => {
                        this.searchRows = this.tempSearchRows;
                    });
            }
            else {
                //Get the templates for the component level CharTypeID
                this.showTableView = false;

                //Usages
                if (row.key == Consts.CharTypeIDs.usage) {
                    this.getComponentRows(lastSelectedEntity, Consts.CharTypeIDs.usage);
                }
                //Rights
                else if (row.key == Consts.CharTypeIDs.right) {
                    this.getComponentRows(lastSelectedEntity, Consts.CharTypeIDs.right);
                }
                //Royalty
                else if (row.key == Consts.CharTypeIDs.royalty) {
                    this.getComponentRows(lastSelectedEntity, Consts.CharTypeIDs.royalty);
                }
            }
        }
    }

    private selectEntityRow(selectedEntity, selectedEntityCharTypeID) {
        this.hasSelectedEntity = true;
        this.showPaging = false;

        if (Utils.IdBuilder.splitEntityID(selectedEntity).recID == -1) {
            this.searchRows = [{
                key: selectedEntityCharTypeID,
                value: "Details"
            }];
        } else {
            this.loading = true;
            this.entityService.getEntityRelationships(selectedEntity)
                .then((childRelationships) => {
                    let associatedCharTypes: Models.IKeyValuePair<any, string>[] = [];

                    let uniqueCharTypeIDs = _.unique(childRelationships.map(cr => cr.childCharTypeID));

                    uniqueCharTypeIDs.forEach(cr => {
                        if (this.relativeProfileOption == 3) {
                            //Only get Tables
                            if (cr != Consts.CharTypeIDs.usage) {
                                return;
                            }
                        }

                        associatedCharTypes.push({
                            key: cr,
                            value: this.getCharDataName(cr)
                        });
                    });

                    //Sort the rows by modules, then by components
                    let sortList = [2, 16, 1, 4, 17, 15, 7, 3, 5, 10, 13, 14];

                    let sorted = _.sortBy(_.unique(associatedCharTypes), function (obj) {
                        return _.indexOf(sortList, obj.key);
                    });

                    //We only want Details when the current entity is not a component
                    if (!this.isRelative) {
                        sorted.unshift({
                            key: selectedEntityCharTypeID,
                            value: "Details"
                        });
                    }

                    this.searchRows = sorted;

                    if (sorted.length == 0) {
                        this.showNoResultsMessage = true;
                    }
                    else {
                        this.showNoResultsMessage = false;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    private selectComponentRow(entityID: string, row: Models.IKeyValuePair<any, string>) {
        this.showTableView = true;
        this.hasSelectedEntity = true;

        let isEntityID = Utils.IdBuilder.isEntityID(row.key);
        let isTemplateID = Utils.IdBuilder.isTemplateID(row.key);

        let charTypeID;
        let templateID;

        if (isTemplateID) {
            charTypeID = Utils.IdBuilder.splitTemplateID(row.key).charTypeID;
            templateID = Utils.IdBuilder.splitTemplateID(row.key).templateID;
            this.createTableView(entityID, templateID, charTypeID);
        } else if (isEntityID) {
            //This means we've selected a table row to view its amounts
            this.createAmountTableView(row.key);
        }
    }

    private createTableView(entityID: string, templateID: number, charTypeID: number) {
        this.tableEntityID = entityID;
        this.tableCharTypeID = charTypeID;
        this.tableTemplateID = templateID;
        this.tableRelID = null;
        this.loading = true;
        this.notifyService.startProgress();

        this.dateCalcService.getDateMathRelatedEntityPairs(entityID, charTypeID, templateID, (this.tableViewPage - 1) * this.rowCount, this.rowCount, this.keywords)
            .then((results) => {
                this.tableHeaderCells = [];
                this.tableRows = [];
                this.tempSearchRows = [];
                this.searchRows = [];
                this.tableRowsWithAmounts = [];
                if (results.entities.length === 0) {
                    this.showNoResultsMessage = true;
                    return;
                }
                let cmds = Utils.AclUtil.filterCMDsByRights(this.aclService.acls, results.entities[0].charDataCollection.templateMetaData, Consts.AccessRight.Read);
                cmds = cmds.filter(cmd => cmd.tagLabel == "entity_title" || cmd.systemIndicator != -1);

                let dateCmds = cmds.filter(cmd => cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date);

                let tempTableRows: ITableRow[] = [];
                this.showNoResultsMessage = false;

                //Determine the table headers
                cmds.forEach((cmd) => {
                    this.tableHeaderCells.push({
                        tagLabel: cmd.tagLabel,
                        isDate: cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date,
                        value: cmd.label,
                        charID: cmd.characteristicID
                    });
                });

                let promises: ng.IPromise<any>[] = [];

                //If the table view is for a Usage, then check if any of the rows have amounts, if so, we need an additional header column
                //at the beginning of the row
                if (charTypeID == Consts.CharTypeIDs.usage) {
                    this.tableRowsWithAmounts = results.tableRecIDsWithAmounts;
                    if (results.tableRecIDsWithAmounts.length > 0) {
                        if (!this.tableHeaderCells.some(c => c.tagLabel == "AmountColumn")) {
                            this.tableHeaderCells.unshift({
                                tagLabel: "AmountColumn",
                                isDate: false,
                                value: "   ",
                                charID: -1
                            });
                        }
                    }
                }

                if (charTypeID == Consts.CharTypeIDs.usage || charTypeID == Consts.CharTypeIDs.right) {
                    if (_.keys(results.catalogItemPipeList).length > 0) {
                        if (!this.tableHeaderCells.some(c => c.tagLabel == "CatalogItemColumn")) {
                            this.tableHeaderCells.unshift({
                                tagLabel: "CatalogItemColumn",
                                isDate: false,
                                value: "Catalog Items",
                                charID: -1
                            });
                        }
                    }

                    if (_.keys(results.projectPipeList).length > 0) {
                        if (!this.tableHeaderCells.some(c => c.tagLabel == "ProjectColumn")) {
                            this.tableHeaderCells.unshift({
                                tagLabel: "ProjectColumn",
                                isDate: false,
                                value: "Projects",
                                charID: -1
                            });
                        }
                    }

                    if (_.keys(results.contactPipeList).length > 0) {
                        if (!this.tableHeaderCells.some(c => c.tagLabel == "ContactColumn")) {
                            this.tableHeaderCells.unshift({
                                tagLabel: "ContactColumn",
                                isDate: false,
                                value: "Contacts",
                                charID: -1
                            });
                        }
                    }
                }

                //Populate data
                results.entities.forEach((pair) => {

                    tempTableRows.push({
                        entityID: pair.record.id,
                        relID: Utils.IdBuilder.buildRelationshipID(pair.relationship),
                        charDatas: pair.charDataCollection.charDatas,
                        catalogItemPipeList: results.catalogItemPipeList[pair.relationship.relRecID],
                        contactPipeList: results.contactPipeList[pair.relationship.relRecID],
                        projectPipeList: results.projectPipeList[pair.relationship.relRecID]
                    });
                    moment.locale(navigator.language);
                    dateCmds.forEach((cmd) => {
                        let dateField = pair.charDataCollection.charDatas[cmd.tagLabel];

                        if (dateField != null && dateField[0] != null) {
                            this.tempSearchRows.push({
                                key: "|" + dateField[0].recCharID.toString(),
                                value: cmd.label + " | " + dateField[0].value
                            });

                            this.charDateData.push({
                                key: cmd.label + " | " + dateField[0].value,
                                value: cmd.characteristicID
                            });
                            dateField[0].value = moment(dateField[0].value).format("L");
                        }
                        else {
                            this.tempSearchRows.push({
                                key: "|0",
                                value: cmd.label + " | [no date value set]"
                            });

                            this.charDateData.push({
                                key: cmd.label + " | [no date value set]",
                                value: cmd.characteristicID
                            });
                        }
                    });
                });

                this.tableRows = tempTableRows;
                this.pagedTableRows = this.tableRows;

                this.totalComponentColumns = this.tableHeaderCells.length;
                this.tableViewNumFound = results.numFound;
                this.tableViewPageCount = Math.ceil(results.numFound / this.rowCount);
            })
            .finally(() => {
                this.loading = false;
                this.notifyService.endProgress();
            });
    }

    private createAmountTableView(relID: string) {
        this.tableEntityID = null;
        this.tableCharTypeID = null;
        this.tableTemplateID = null;
        this.tableRelID = relID;
        this.notifyService.startProgress();
        this.loading = true;

        this.dateCalcService.getDateMathRelatedEntityPairs(relID, Consts.CharTypeIDs.amount, -1, (this.tableViewPage - 1) * this.rowCount, this.rowCount)
            .then((results) => {
                let amounts = results.entities;
                let firstAmount = amounts[0];

                //let tags = firstAmount.charDataCollection.templateMetaData.characteristicMetaDatas.filter(t => t.systemIndicator != -1 && t.visibilityIndicator > 0);
                let cmds = Utils.AclUtil.filterCMDsByRights(this.aclService.acls, firstAmount.charDataCollection.templateMetaData, Consts.AccessRight.Read).filter(t => t.systemIndicator != -1);

                let dateCmds = cmds.filter(t => t.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date);

                let tempTableRows: ITableRow[] = [];
                this.tableHeaderCells = [];
                this.tableRows = [];
                this.tempSearchRows = [];
                this.searchRows = [];
                this.tableRowsWithAmounts = [];

                //Amounts only ever show 6 table headers plus a date field since there can be Amounts of different templates on a Table row
                let shownAmountColumnTags: string[] = [
                    "entity_template",
                    "entity_status",
                    "category",
                    "description",
                    "currency",
                    "amount"
                ];

                //Determine the table headers
                cmds.forEach((cmd) => {
                    let isDate = false;

                    if (cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date) {
                        isDate = true;
                    }

                    if (shownAmountColumnTags.indexOf(cmd.tagLabel) > -1 || isDate) {
                        this.tableHeaderCells.push({
                            tagLabel: cmd.tagLabel,
                            isDate: isDate,
                            value: cmd.label,
                            charID: cmd.characteristicID
                        });
                    }
                });

                if (dateCmds.length == 0) {
                    //Show the no results message
                    this.showNoResultsMessage = true;
                }
                else {
                    this.showNoResultsMessage = false;

                    //Populate data
                    amounts.forEach((amount) => {
                        let charDatas = amount.charDataCollection.charDatas;

                        tempTableRows.push({
                            entityID: amount.record.id,
                            relID: null,
                            charDatas: charDatas
                        });

                        dateCmds.forEach((cmd) => {
                            let dateField = amount.charDataCollection.charDatas[cmd.tagLabel];

                            if (dateField != null && dateField[0] != null) {
                                this.tempSearchRows.push({
                                    key: "|" + dateField[0].recCharID.toString(),
                                    value: cmd.label + " | " + dateField[0].value
                                });

                                this.charDateData.push({
                                    key: cmd.label + " | " + dateField[0].value,
                                    value: cmd.characteristicID
                                });
                            }
                            else {
                                this.tempSearchRows.push({
                                    key: "|0",
                                    value: cmd.label + " | [no date value set]"
                                });

                                this.charDateData.push({
                                    key: cmd.label + " | [no date value set]",
                                    value: cmd.characteristicID
                                });
                            }
                        });
                    });

                    //Meta Data for paging
                    this.totalComponentColumns = this.tableHeaderCells.length;
                    this.tableViewNumFound = results.numFound;
                    this.tableViewPageCount = Math.ceil(results.numFound / this.rowCount);

                    this.tableRows = tempTableRows;
                    this.pagedTableRows = this.tableRows;

                }
            })
            .finally(() => {
                this.notifyService.endProgress();
                this.loading = false;
            });

    }

    private closeSearchDropPanel() {
        this.$scope.$broadcast(Consts.Events.RLDropPanelClose);
    }

    public ResetAdditionalDateMath(index: number) {
        this.tempYearQuantity = null;
        this.tempMonthQuantity = null;
        this.tempWeekQuantity = null;
        this.tempDayQuantity = null;
        this.tempFrequencyID = 1;
        this.tempCalculatePriorTo = false;
        this.dateMathCalcRels[index].rel.yearQuantity = null;
        this.dateMathCalcRels[index].rel.monthQuantity = null;
        this.dateMathCalcRels[index].rel.weekQuantity = null;
        this.dateMathCalcRels[index].rel.dayQuantity = null;
        this.dateMathCalcRels[index].rel.frequencyID = null;
        this.dateMathCalcRels[index].rel.isPriorTo = null;
        this.closeSearchDropPanel();
    }

    public CancelAdditionalDateMath() {
        this.tempYearQuantity = null;
        this.tempMonthQuantity = null;
        this.tempWeekQuantity = null;
        this.tempDayQuantity = null;
        this.tempFrequencyID = 1;
        this.tempCalculatePriorTo = false;
        this.closeSearchDropPanel();
    }
    //--

    //Component
    private getComponentRows(entityID: string, charTypeID: number): ng.IPromise<any> {
        this.notifyService.startProgress();
        this.loading = true;
        this.showPaging = false;

        return this.searchService.getRelatedEntityTemplates(entityID, charTypeID)
            .then((results) => {
                this.searchRows = _(results)
                    .sortBy(t => t.templateName)
                    .map(t => ({ key: Utils.IdBuilder.buildTemplateID(0, charTypeID, t.templateID), value: t.templateName }))
                    .value();
                this.loading = false;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    public RemoveDateMath(dateMathRelID: number) {
        this.removeDateMathCalcRel(dateMathRelID);
        this.updateDisplay().then(() => this.resetFields());
    }

    private removeDateMathCalcRel(dateMathRelID: number) {
        let calcRel = _.find(this.dateMathCalcRels, (cr) => cr.rel.dateMathRelID == dateMathRelID);

        if (this.dateMathCalcRels.length == 1) {
            this.trackCalcAs(calcRel.calc, "deleted");
        }
        this.trackRelAs(calcRel.rel, "deleted");

        if (this.dateMathCalcRels.length == 1) {
            _.remove(this.fieldDate.ext.dateMath.calcs, (calc) => calc.dateMathCalcID == calcRel.calc.dateMathCalcID);
        }

        _.remove(this.fieldDate.ext.dateMath.relationships, (rel) => rel.dateMathRelID == calcRel.rel.dateMathRelID);
    }

    public GetPriorToText(value: boolean) {
        if (value == null) {
            return "";
        }

        return _.find(this.dateMathTimeframeValues, v => v.value == value).text;
    }

    public PreAdditionalDateMath(index: number) {
        this.tempYearQuantity = this.dateMathCalcRels[index].rel.yearQuantity;
        this.tempMonthQuantity = this.dateMathCalcRels[index].rel.monthQuantity;
        this.tempWeekQuantity = this.dateMathCalcRels[index].rel.weekQuantity;
        this.tempDayQuantity = this.dateMathCalcRels[index].rel.dayQuantity;
        this.tempFrequencyID = this.dateMathCalcRels[index].rel.frequencyID;
        this.tempCalculatePriorTo = this.dateMathCalcRels[index].rel.isPriorTo;
        if (this.tempFrequencyID == null) {
            this.tempFrequencyID = 1;
        }

        if (this.tempCalculatePriorTo == null) {
            this.tempCalculatePriorTo = false;
        }
    }

    public ApplyAdditionalDateMath(index: number) {
        this.dateMathCalcRels[index].rel.yearQuantity = this.tempYearQuantity;
        this.dateMathCalcRels[index].rel.monthQuantity = this.tempMonthQuantity;
        this.dateMathCalcRels[index].rel.weekQuantity = this.tempWeekQuantity;
        this.dateMathCalcRels[index].rel.dayQuantity = this.tempDayQuantity;
        this.dateMathCalcRels[index].rel.frequencyID = this.tempFrequencyID;
        this.dateMathCalcRels[index].rel.isPriorTo = this.tempCalculatePriorTo;

        this.trackRelAs(this.dateMathCalcRels[index].rel, "updated");
        this.closeSearchDropPanel();
    }

    private processSelectedDateField(index: number, recCharID: number, charID: number, dateField: string, selectedComponentEntity: string, addRelationship: boolean = true) {
        this.selectedDateFieldInformation = "";
        let selectedDateFieldName = "";
        this.hasDateMath = true;
        selectedDateFieldName = dateField;

        //This is only valid for component values
        let splitComponentEntity;

        if (selectedComponentEntity) {
            splitComponentEntity = selectedComponentEntity.split("|");
        }

        let matchedDateField = _.find(this.tempSearchRows, sr => sr.key == "|" + recCharID);

        if (recCharID == 0) {
            //Get the match based on the value instead
            matchedDateField = _.find(this.tempSearchRows, sr => sr.value == selectedDateFieldName);
        }

        if (matchedDateField != null) {
            selectedDateFieldName = matchedDateField.value;
            this.selectedDateFieldFriendlyName = selectedDateFieldName;
        }

        if (this.selectedObjects.length > 0) {
            let componentEntityValue: string;
            let selectedParent: Models.IKeyValuePair<any, string> = { key: this.entityID, value: this.recTitle };
            let parentTemplateName: string;

            //Setup the breadcrumb
            //Get the char type and the Rec ID of the first selected object to display
            let firstKey = _.first(this.selectedObjects).key;

            if (!Utils.IdBuilder.isEntityID(firstKey)) {
                this.onlyAssociatedEntities = false;
            }

            this.selectedObjects.forEach(so => {
                this.selectedDateFieldInformation += so.value + " > ";
            });

            if (splitComponentEntity && splitComponentEntity[1]) {
                componentEntityValue = splitComponentEntity[1];

                this.selectedDateFieldInformation += componentEntityValue + " > ";
            }

            //Change 09/09/1900 to TBD
            this.selectedDateFieldInformation += selectedDateFieldName.replace("09/09/1900", "TBD");
            //Change 09/09/9999 to Perpetuity
            this.selectedDateFieldInformation += selectedDateFieldName.replace("09/09/9999", "Perpetuity");

            //End breadcrumb

            if (addRelationship) {
                //Get the selected "parent" of the matchedDateField
                //If we have a selected component entity, then that is our parent entity
                let lastSelectedObject = _.last(this.selectedObjects).key;

                if (Utils.IdBuilder.isEntityID(lastSelectedObject) && Utils.IdBuilder.splitEntityID(lastSelectedObject).charTypeID == Consts.CharTypeIDs.relationship) {
                    let splitEntity = Utils.IdBuilder.splitEntityID(this.entityID);
                    let tempRecID = Utils.IdBuilder.isEntityID(splitComponentEntity[0]) ? Utils.IdBuilder.splitEntityID(splitComponentEntity[0]).recID : _.parseInt(splitComponentEntity[0]);
                    selectedParent = {
                        key: Utils.IdBuilder.buildEntityID(splitEntity.divID, Consts.CharTypeIDs.amount, tempRecID),
                        value: splitComponentEntity[1]
                    };

                    //Since the user did not select a template, we do not need to show one
                }
                //Check if the last item selected is an entity ID, if so, that's our parent.
                else if (Utils.IdBuilder.isEntityID(_.last(this.selectedObjects).key)) {
                    selectedParent = _.last(this.selectedObjects);
                }
                else if (Utils.IdBuilder.isTemplateID(_.last(this.selectedObjects).key)) {
                    //We want to create the entity ID from the passed in rec

                    selectedParent = {
                        key: splitComponentEntity[0],
                        value: splitComponentEntity[1]
                    };

                    //If the last item selected is a template ID, then we have a parentTemplateName to pass in
                    parentTemplateName = _.last(this.selectedObjects).value;
                }
                else {
                    if (Utils.CharUtil.IsModuleLevelCharType(_.last(this.selectedObjects).key)) {
                        if (Utils.IdBuilder.isEntityID(this.selectedObjects[this.selectedObjects.length - 2].key)) {
                            //We want the second to last item as the entity
                            selectedParent = this.selectedObjects[this.selectedObjects.length - 2];
                        }
                    }
                }

                this.setDateMath(selectedParent.key, charID, recCharID);
            }
        }
    }

    private getParent(entityID: string): ng.IPromise<any> {
        return this.entityService.getEntityRecord(entityID)
            .then((entity) => {
                if (entity.charTypeID && entity.charTypeID != Consts.CharTypeIDs.relationship && entity.charTypeID != Consts.CharTypeIDs.amount) {
                    this.selectedObjects.unshift({
                        key: entityID,
                        value: entity.title
                    });

                    if (!Utils.CharUtil.IsModuleLevelCharType(entity.charTypeID)) {
                        this.selectedObjects.unshift({
                            key: entity.templateID,
                            value: entity.template
                        });
                    }

                    this.selectedObjects.unshift({
                        key: entity.charTypeID,
                        value: this.getCharDataName(entity.charTypeID)
                    });
                }

                if (Utils.IdBuilder.splitEntityID(entityID).charTypeID == Consts.CharTypeIDs.relationship) {
                    return this.entityService.getEntityRelationship(entityID)
                        .then((result) => {
                            if (!Utils.CharUtil.IsModuleLevelCharType(result.childCharTypeID)) {
                                let childEntityID = Utils.IdBuilder.buildEntityID(result.divisionID, result.childCharTypeID, result.childRecID);

                                return this.getParent(childEntityID);
                            }
                        });
                } else {
                    return this.entityService.getEntityParentRelationship(entityID)
                        .then((results) => {
                            if (results.length > 0) {
                                let firstParent = results[0];

                                if (!Utils.CharUtil.IsModuleLevelCharType(firstParent.parentCharTypeID)) {
                                    let parentEntityID = Utils.IdBuilder.buildEntityID(firstParent.divisionID, firstParent.parentCharTypeID, firstParent.parentRecID);

                                    return this.getParent(parentEntityID);
                                }
                                else {
                                    return this.$q.when(null);
                                }
                            }
                        });
                }
            });
    }
    // --

    public SetCompareToDate() {
        //Check if it's a date
        moment.locale(navigator.language);
        var dateValue = moment(this.compareToDate, "L").locale(navigator.language);
        if (dateValue.isValid()) {
            let newValue = dateValue.toDate();
            if (isNaN(newValue.getTime())) {
                newValue = null;
            }
            this.dateMathCalcRels
                .forEach((calcRel) => {
                    calcRel.calc.compareToDate = newValue.toISOString();
                    this.trackCalcAs(calcRel.calc, "updated");
                });
            this.loadFromCharData();
        }
    }

    public SetCalcCondition() {
        var calcConditionID = this.calcConditionID;
        if (calcConditionID) {
            this.dateMathCalcRels.forEach((calcRel) => {
                calcRel.calc.calcConditionID = calcConditionID;
                this.trackCalcAs(calcRel.calc, "updated");
            });
            this.loadFromCharData();
        }
    }

    public SetCalcDateOption(){
        var calcDateOptionID = this.calcDateOptionID;
        if (calcDateOptionID != null) {
            this.dateMathCalcRels.forEach((calcRel) => {
                calcRel.calc.dateOptionID = calcDateOptionID ? 1 : 0;
                this.trackCalcAs(calcRel.calc, "updated");
            });
            this.loadFromCharData();
        }
    }

    public SelectRelativeCatalogChar(char) {
        let recId = Utils.IdBuilder.getNewTempRecID();

        if (!this.isRelative) {
            let charData = _.first(this.firstCatalogItemCharDataCol.charDatas[char.tagLabel]);
            if (charData) {
                recId = charData.recCharID;
            }
        }

        let catalogRecID = this.firstCatalogItem ? this.firstCatalogItem : -1;

        this.setDateMath(
            Utils.IdBuilder.buildEntityID(char.divID, char.charTypeID, catalogRecID),
            char.characteristicID,
            recId,
            true);
        this.closeSearchDropPanel();
        this.isRelativeToCatalog = false;
    }

    private getCommonCmds() {
        // get all date chars from each catalog item
        this.notifyService.startProgress();
        this.dateCalcService.getCommonDateChars(Consts.CharTypeIDs.property)
            .then((results) => {
                this.commonCmds = results;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private getTableTriggerParentEntity() {
        this.notifyService.startProgress();
        this.isRelativeToCatalog = false;
        let request: Models.IAdvancedSearchModel = {
            charTypeID: Consts.CharTypeIDs.mock,
            filterByTemplateIds: [2],
            searchGroups: [],
            keywords: "",
            page: 1,
            rowCount: 1
        };

        this.searchService.advancedSearch(request)
            .then((results) => {
                this.tableParentEntityID = _.first(results.documents).entityID;
                this.tableParentTitle = _.first(results.documents).title;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private updateDateCalcRelationshipSortOrder(updatedList: ICalcRel[]) {
        // Set the sort order of each date math calc relationship
        this.dateMathCalcRels = updatedList.reduce<ICalcRel[]>((prev, current) => {
            let index = prev.length;
            let sortOrderUpdated = index != current.rel.sortOrder;
            current.rel.sortOrder = index;

            // If the order changed, then set tracking
            if (sortOrderUpdated) {
                this.trackRelAs(current.rel, "updated");
            }

            prev.push(current);

            return prev;
        }, []);
    }
}
